/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const o=o=>o;export{o as noop};
//# sourceMappingURL=noop.js.map
